import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_entity_test = _resolveComponent("g-entity-test");
    return (_ctx.window?.navigation?.isTest)
        ? (_openBlock(), _createBlock(_component_g_entity_test, {
            key: 0,
            window: _ctx.window
        }, null, 8, ["window"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx._component)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx._component), _normalizeProps(_mergeProps({ key: 0 }, _ctx._componentProps)), null, 16))
                : _createCommentVNode("", true)
        ], 64));
}
